import React from "react";
import "./reports.scss";
import AccessFrom from "./accessFrom";
import Hand from "./hand";
import OurApps from "./ourApps";
import SuitableApps from "./suitableApps";
import Potency from "./potency";
import Letsgo from "../connectors/letsgo";

function Reports() {
  return (
    <div className="container-reports">
      <div className="section-hand">
        <Hand />
      </div>
      <div className="section-access-from">
        <AccessFrom />
      </div>
      <div className="section-our-apps">
        <OurApps />
      </div>
      <div className="section-suitable-apps">
        <SuitableApps />
      </div>
      <div className="section-potency">
        <Potency />
      </div>
      <div className="section-lets-go">
        <Letsgo />
      </div>
    </div>
  );
}

export default Reports;
